<template>
    <div class="card">
        <div class="col-12">
            <h1 class="page-title mt-3">Phân quyền người dùng</h1>
        </div>

        <div class="col-xl-12 mb-2">
            <div class="row">
                <div class="col-xs-12 col-md-3">
                    <input type="text" class="form-control" v-model="filters.fullName" placeholder="Nhập tên nhân viên">
                </div>
                <div class="col-xs-12 col-md-3">
                    <input type="text" class="form-control" v-model="filters.aliasID" placeholder="Nhập mã nhân viên">
                </div>
                <div class="col-xs-12 col-md-3">
                    <input type="text" class="form-control" v-model="filters.username" placeholder="Nhập tên đăng nhập">
                </div>
                <div class="col-xs-12 col-md-3">
                    <button class="btn btn-primary mt-1" @click="fetchUserList">
                        Tìm kiếm
                    </button>
                    <button class="btn btn-secondary mt-1 ml-2" @click="resetFilters">
                        Xoá tìm kiếm
                    </button>
                </div>
            </div>
        </div>

        <div class="col-xl-12">
            <div class="table-container">
                <table class="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th>Module</th>
                            <th>Sub Module</th>
                            <th>Action</th>
                            <th v-for="user in userList" :key="user.userId">
                                {{ user.fullName }}<br />
                                <small>Mã: {{ user.aliasID }}</small><br />
                                <small>Tên đăng nhập: {{ user.username }}</small>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(actions, module) in permissionList">
                            <tr v-for="(action, index) in actions" :key="`${module}-${action.id}`">
                                <td v-if="index === 0" :rowspan="actions.length">
                                    <strong>{{ moduleLabels[module] || module }}</strong>
                                </td>

                                <td>{{ action.sub }}</td>
                                <td>{{ actionLabels[action.action] || action.action }}</td>
                                <td v-for="user in userList" :key="`u${user.userId}-p${action.id}`" class="text-center">
                                    <input type="checkbox" :checked="user.permissions.includes(action.id)"
                                        @change="togglePermission(user.userId, action.id, $event.target.checked)" />
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row d-flex justify-end">
            <div class="col-xs-12 col-md-4">
                <button class="btn btn-primary mt-3" @click="submitAll" :disabled="loading">
                    <span v-if="loading">
                        <i class="fas fa-spinner fa-spin"></i> Đang lưu...
                    </span>
                    <span v-else>
                        Lưu tất cả
                    </span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { PERMISSION_LIST, MODULE_LABELS, ACTION_LABELS } from '@/constants/permissions';
import apiServer from "@/axiosServer";


export default {
    data() {
        return {
            userList: [],
            permissionList: {},
            permissionHeaders: [],
            filters: {
                fullName: '',
                aliasID: '',
                username: ''
            },
            loading: false,
        }
    },
    computed: {
        moduleLabels() {
            return MODULE_LABELS
        },
        actionLabels() {
            return ACTION_LABELS
        }
    },
    created() {
        this.permissionList = PERMISSION_LIST
        this.flattenPermissions()
        this.fetchUserList()
    },
    methods: {
        // Đưa toàn bộ module/action thành mảng 1 chiều
        flattenPermissions() {
            const flat = []
            for (const [module, actions] of Object.entries(this.permissionList)) {
                for (const act of actions) {
                    flat.push({
                        id: act.id,
                        module,
                        action: act.action
                    })
                }
            }
            this.permissionHeaders = flat
        },

        async fetchUserList() {
            try {
                this.loading = true
                const res = await apiServer.get('/api/v1/user/permission', {
                    params: {
                        fullName: this.filters.fullName,
                        aliasID: this.filters.aliasID,
                        username: this.filters.username
                    }
                })
                this.userList = res.data.data.items.map(user => ({
                    ...user,
                    originalPermissions: [...user.permissions]
                }))
            } catch (err) {
                this.$toast.error('Không thể tải danh sách người dùng')
            } finally {
                this.loading = false
            }
        },

        togglePermission(userId, permissionId, isChecked) {
            const user = this.userList.find(u => u.userId === userId)
            if (!user) return

            const set = new Set(user.permissions)
            isChecked ? set.add(permissionId) : set.delete(permissionId)
            user.permissions = Array.from(set)
        },

        resetFilters() {
            this.filters.fullName = ''
            this.filters.aliasID = ''
            this.filters.username = ''
            this.fetchUserList()
        },

        async submitAll() {
            this.loading = true
            const payload = { add: [], remove: [] }

            for (const user of this.userList) {
                const before = new Set(user.originalPermissions)
                const after = new Set(user.permissions)

                const add = [...after].filter(id => !before.has(id))
                const remove = [...before].filter(id => !after.has(id))

                if (add.length) payload.add.push({ userId: user.userId, permissionIds: add })
                if (remove.length) payload.remove.push({ userId: user.userId, permissionIds: remove })
            }

            try {
                await apiServer.post('/api/v1/user/permission/action', payload)
                this.fetchUserList() // reload lại dữ liệu
            } catch (err) {
                console.log(err);
                alert('Cập nhật thất bại')
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style scoped>
.table-responsive {
    overflow-x: auto;
}

table {
    min-width: 1200px;
}

th,
td {
    white-space: nowrap;
}

.table-container {
    max-height: 500px;
    overflow-y: auto;
    overflow-x: auto;
}

.table thead th {
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 2;
    border-bottom: 2px solid #dee2e6;
}

.table {
    min-width: 1000px;
}
</style>
